// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-pages-index-page-index-brands-content-brands-bplvl{display:grid;grid-gap:24px}.components-pages-index-page-index-brands-content-brands-bplvl.components-pages-index-page-index-brands-content-desktop-bhedt{grid-template-columns:repeat(8,1fr)}.components-pages-index-page-index-brands-content-brands-bplvl.components-pages-index-page-index-brands-content-mobile-bpoek{grid-template-columns:repeat(2,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brands": "components-pages-index-page-index-brands-content-brands-bplvl",
	"desktop": "components-pages-index-page-index-brands-content-desktop-bhedt",
	"mobile": "components-pages-index-page-index-brands-content-mobile-bpoek"
};
module.exports = ___CSS_LOADER_EXPORT___;
